import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { selectBuyerNewHomeBudgetWithCap } from '../../../../../store/selectors/home/equity'
import { NewHomeDetail } from './NewHomeDetail'
import { DREAM_HOME_TOPIC_KEY } from '../../../../../constants/topicKeys'

export default {
  GemContainer: connect(state => ({
    qaTag: 'dreamHomeGem', // Leaving as old event label for backwards compatibility
    amount: selectBuyerNewHomeBudgetWithCap(state),
  })),
  Detail: NewHomeDetail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.dreamHomeQuestion',
      defaultMessage: 'How do I get started?',
    },
    topic: {
      id: 'Homeowner.purchasePower.dreamHomeTopic',
      defaultMessage: 'buying their dream home',
    },
  }),
  topicKey: DREAM_HOME_TOPIC_KEY,
}
